import type { EdgeData } from '@ipfabric/utils';
import type { GraphData } from 'components/Graph/model/GraphData';
import type { Draft } from 'immer';

export const putEdgeToGraphDraft =
  (draft: Draft<GraphData>) =>
  (edge: EdgeData): void => {
    draft.edges[edge.id] = edge;
  };
